// File: src/pages/buyer/sections/ProductDescription.jsx
import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Row, Col, Form, Button, Spinner } from "react-bootstrap";
import TipTapEditor from "../../../../components/seller/TipTapEditor.jsx";
import CIcon from "@coreui/icons-react";
import { cilLightbulb } from "@coreui/icons";
import { FaLightbulb } from "react-icons/fa";

const ProductDescription = ({ kycType, onGenerateAi, aiLoading }) => {
  const {
    control,
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  return (
    <div className="border rounded p-4 mb-4 bg-white">
      <h5 className="fw-semibold mb-4">Product Information</h5>

      {/* Product Name */}
      <Row className="mb-3">
        <Col md={12}>
          <Form.Group>
            <Form.Label>Product Name</Form.Label>
            <Form.Control {...register("name")} />
            {errors.name && (
              <div className="text-danger small">{errors.name.message}</div>
            )}
          </Form.Group>
        </Col>
      </Row>

      {/* Product Description */}
      <Row>
        <Col md={12}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Form.Label className="mb-0">Description</Form.Label>

            <Button
              variant="outline-secondary"
              size="sm"
              disabled={aiLoading}
              onClick={onGenerateAi}
            >
              {aiLoading ? (
                <Spinner size="sm" />
              ) : (
                <>
                  <span className="d-inline-flex align-items-center gap-1">
                    <FaLightbulb />
                    <span>Generate with AI</span>
                  </span>
                </>
              )}
            </Button>
          </div>

          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TipTapEditor
                content={field.value}
                onChange={field.onChange}
              />
            )}
          />

          {errors.description && (
            <div className="text-danger small mt-2">
              {errors.description.message}
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default React.memo(ProductDescription);
